class DarkrimAboutDrivesCarousel extends HTMLElement {
  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-component');
    this.previousButton = this.querySelector('[data-darkrim-previous]');
    this.nextButton = this.querySelector('[data-darkrim-next]');
    this.total = Number(this.dataset.slideCount) || 0;

    this.slideshow?.setAttribute('in-viewport', '');
    this.addEventListener('slideshow:select', this.handleSlideSelect);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.updateArrows(0);
  }

  disconnectedCallback() {
    this.removeEventListener('slideshow:select', this.handleSlideSelect);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleSlideSelect = (event) => {
    if (!this.slideshow?.contains(event.detail.slide)) return;
    this.updateArrows(event.detail.index);
  };

  handleBlockSelect = (event) => {
    if (!(event.target instanceof Element)) return;

    const slide = event.target.closest('slideshow-slide');
    const slides = Array.from(this.slideshow?.querySelectorAll('slideshow-slide') || []);
    const index = slides.indexOf(slide);

    if (index >= 0) this.slideshow?.select(index, undefined, { animate: false });
  };

  updateArrows(index) {
    const current = Math.min(Math.max(index + 1, 1), Math.max(this.total, 1));

    if (this.previousButton) this.previousButton.disabled = current === 1;
    if (this.nextButton) this.nextButton.disabled = this.total <= 1 || current === this.total;
  }
}

if (!customElements.get('darkrim-about-drives-carousel')) {
  customElements.define('darkrim-about-drives-carousel', DarkrimAboutDrivesCarousel);
}
